<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('qualitycheck.customer.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="customertagSelectItems"
            v-model="item.tags"
            :items="customertagSelectItems"
            :error-messages="tagErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.customer.tags')"
            item-text="name"
            item-value="@id"
            :search-input.sync="search"
            multiple
            persistent-hint
            chips
            @change="changeTag()"
            >
                 <template v-slot:no-data>
                   <v-list-item>
                     <v-list-item-content>
                       <v-list-item-title>
                         {{ $t('global.no_result') }} "<strong>{{ search }}</strong>". {{ $t('global.addcombo1') }} <kbd>enter</kbd> {{ $t('global.addcombo2') }}
                       </v-list-item-title>
                     </v-list-item-content>
                   </v-list-item>
                 </template>
                 <template v-slot:selection="{ attrs, item, parent, selected }">
                   <v-chip
                     v-if="item === Object(item)"
                     v-bind="attrs"
                     color="primary"
                     :input-value="selected"
                     label
                   >
                     <span class="pr-2">
                       {{ item.name }}
                     </span>
                     <v-icon
                       small
                       @click="parent.selectItem(item)"
                     >
                       mdi-close
                     </v-icon>
                   </v-chip>
                 </template>
               </v-combobox>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="distributorSelectItems"
            v-model="item.distributor"
            :items="distributorSelectItems"
            :error-messages="distributorErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.distributor.distributor')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.description"
            :error-messages="descriptionErrors"
            :label="$t('qualitycheck.customer.description')"
            auto-grow
            rows="1"
            row-height="15"
            @input="$v.item.description.$touch()"
            @blur="$v.item.description.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('qualitycheck.customer.comment')"
            auto-grow
            rows="1"
            row-height="15"
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';

export default {
  name: 'CustomerForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.customertagGetSelectItems();
    this.distributorGetSelectItems();

  },
  data() {
    return {
        name: null,

        comment: null,
        description: null,
        distributor: null,
        tags: null,
    };
  },
  computed: {
    isLoading() {
      return (
      this.isLoading_customertag ||
      this.isLoading_distributor
       );
    },
    ...mapFields('customertag', {
      customertagSelectItems: 'selectItems',
      isLoading_customertag : 'isLoading'
    }),
    ...mapFields('distributor', {
      distributorSelectItems: 'selectItems',
      isLoading_distributor : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    tagErrors() {
      const errors = [];

      if (!this.$v.item.tags.$dirty) return errors;

      has(this.violations, 'tags') && errors.push(this.violations.tags);


      return errors;
    },
    distributorErrors() {
      const errors = [];

      if (!this.$v.item.distributor.$dirty) return errors;

      has(this.violations, 'distributor') && errors.push(this.violations.distributor);


      return errors;
    },

    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);


      return errors;
    },
    descriptionErrors() {
      const errors = [];

      if (!this.$v.item.description.$dirty) return errors;

      has(this.violations, 'description') && errors.push(this.violations.description);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    changeTag() {
      this.item.tags = this.item.tags.map(v => {
        if (typeof v === 'string') {
          if (v.trim() != '' && v.trim().length >= 2) {
            console.log(v);
            v = {
              name: v.trim(),
            }
          }
        }
        return v
      })
    },
    ...mapActions({

      customertagGetSelectItems: 'customertag/fetchSelectItems',
      distributorGetSelectItems: 'distributor/fetchSelectItems',
    }),
  },
  validations: {
    item: {
      name: {
        required,
      },

      comment: {

      },
      description: {

      },
      tags: {
      },
      distributor: {
      },
    }
  }
};
</script>
